module.exports = __webpack_public_path__ + "static/media/item_2_6ll.c4bc281e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_6ll.png
// module id = 123
// module chunks = 0